import { useSelector } from "react-redux";

export function useAuth() {
  const user = useSelector((store) => store.auth);
  return user;
}
